"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTAINER_IMAGE_V1 = exports.OCI_CONFIG_V1 = exports.JSON = exports.LAYER = exports.IMAGE_CONFIG = exports.OCI_INDEX_V1 = exports.OCI_MANIFEST_V1 = exports.MANIFEST_LIST_V2 = exports.MANIFEST_V2 = void 0;
exports.MANIFEST_V2 = "application/vnd.docker.distribution.manifest.v2+json";
exports.MANIFEST_LIST_V2 = "application/vnd.docker.distribution.manifest.list.v2+json";
exports.OCI_MANIFEST_V1 = "application/vnd.oci.image.manifest.v1+json";
exports.OCI_INDEX_V1 = "application/vnd.oci.image.index.v1+json";
exports.IMAGE_CONFIG = "application/vnd.docker.container.image.v1+json";
exports.LAYER = "application/vnd.docker.image.rootfs.diff.tar.gzip";
exports.JSON = "application/json";
exports.OCI_CONFIG_V1 = "application/vnd.oci.image.config.v1+json";
exports.CONTAINER_IMAGE_V1 = "application/vnd.docker.container.image.v1+json";
//# sourceMappingURL=content-types.js.map